module.exports = __webpack_public_path__ + "img/app-screen_2.a7a16cdb.webp";